import { render, staticRenderFns } from "./definition_table.vue?vue&type=template&id=5ec32bde&scoped=true"
import script from "./definition_table.vue?vue&type=script&lang=js"
export * from "./definition_table.vue?vue&type=script&lang=js"
import style0 from "./definition_table.vue?vue&type=style&index=0&id=5ec32bde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec32bde",
  null
  
)

export default component.exports